import styled from "styled-components";
import { FiEdit, FiInfo } from "react-icons/fi";

import FlexBox from "../FlexBox";
import { DAVYS_GREY, PLUM_PURPLE } from "../colors";
import { Body2, Caption, H4 } from "../Headings";
import { IconButton } from "../Buttons";
import HistoryNullImage from "../../../assets/AiChat/ai-chat-null.svg";

const NullState = styled(FlexBox)`
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  padding: 2rem;
  text-align: center;
`;

const TryThisBox = styled(FlexBox)`
  width: 100%;
  flex-direction: column;

  border: 1px solid ${DAVYS_GREY[400]};
  border-radius: 0.5rem;
  overflow: hidden;

  ul {
    margin: 0;
    padding: 1rem 1rem 1rem 2rem;
    text-align: left;
    color: ${DAVYS_GREY[800]};

    li {
      margin-bottom: 0.5rem;
      font-size: 0.875rem;
    }

    li:last-child {
      margin-bottom: 0;
    }
  }
`;

const TryThisHeader = styled(FlexBox)`
  align-items: center;
  gap: 0.25rem;

  padding: 0.75rem 1rem;

  background: ${PLUM_PURPLE[100]};
  color: ${PLUM_PURPLE[800]};
`;

const SearchEmptyState = () => (
  <NullState>
    <img src={HistoryNullImage} alt="No results found" />

    <FlexBox column rowGap="0.5rem" align="center">
      <H4 bold>No Results Found</H4>

      <Body2 textAlign="center">
        We couldn’t find any chats matching your search.
      </Body2>
    </FlexBox>

    <TryThisBox>
      <TryThisHeader>
        <FiInfo size={16} />

        <Caption
          bold
          spacing="0.1rem"
          color={PLUM_PURPLE[800]}
          textTransform="uppercase"
        >
          Try this:
        </Caption>
      </TryThisHeader>

      <ul>
        <li>Check for typos or refine your keywords.</li>
        <li>Use client names, prompt topics, or keywords from the chat.</li>
        <li>Broaden your search if it's too specific.</li>
      </ul>
    </TryThisBox>
  </NullState>
);

const ConversationEmptyState = ({ onStart }) => (
  <NullState>
    <img src={HistoryNullImage} alt="No conversations" />

    <FlexBox column rowGap="0.5rem" align="center">
      <H4 bold>No Conversations Yet</H4>

      <Body2>All your chat history will be saved here.</Body2>
    </FlexBox>

    <IconButton
      onClick={onStart}
      Icon={FiEdit}
      iconPosition="left"
      strokeWidth={3}
      spacing="0.5rem"
    >
      Start a Chat
    </IconButton>
  </NullState>
);

const AiChatHistoryEmptyState = ({ noSearchResults, onStart }) => {
  if (noSearchResults) {
    return <SearchEmptyState />;
  }

  return <ConversationEmptyState onStart={onStart} />;
};

export default AiChatHistoryEmptyState;
